module.exports = __webpack_public_path__ + "static/media/step_5.dc4db33e.png";